import { NextBestActionResponse } from '@/src/types/NextBestAction';

export const getActionCodeName = (nbaInfo: NextBestActionResponse[number]) => {
  if (!nbaInfo?.Action_Sub_Category) return nbaInfo.Action_Code;

  return `${nbaInfo.Action_Code}_${nbaInfo.Action_Sub_Category}`;
};
